/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    ANSWER_DELETE_ERROR,
    ANSWER_UPDATE_ERROR,
    APP_BY_KEY_LIST_FAILURE,
    APP_LIST_FAILURE,
    DOMAIN_CREATE_ERROR,
    DOMAIN_DETAIL_FAILURE,
    DOMAIN_EDIT_FAILURE,
    MY_DOMAIN_LIST_FAILURE,
    MY_COMPANIES_DOMAIN_LIST_FAILURE,
    DOMAIN_CREATE_NOTIFY_ERROR,
    DOMAIN_NOTIFY_EMAIL_LIST_FAILURE,
    DOMAIN_NOTIFY_LIST_FAILURE,
    FAILURE_NAME_FANPAGE_FUNBOT,
    FANPAGE_ANSWER_CREATE_ERROR,
    FANPAGE_CREATE_ERROR,
    FANPAGE_DETAIL_FAILURE,
    FANPAGE_EDIT_FAILURE,
    FANPAGE_GET_HEARS_FAILURE,
    FANPAGE_LIST_FAILURE,
    FANPAGE_POST_CREATE_ERROR,
    FANPAGE_POST_LIST_ERROR,
    FANPAGE_POST_UPDATE_ERROR,
    POST_ANSWER_CREATE_ERROR,
    POST_ANSWER_LIST_ERROR,
    SEGMENT_CREATE_FAILURE,
    SEGMENT_LIST_FAILURE,
    SEGMENT_UPDATE_FAILURE,
    TEMPLATE_DELETE_FAILURE,
    TEMPLATE_EDIT_ERROR,
    TEMPLATE_LIST_FAILURE,
    TEAM_LIST_FAILURE,
    TEAM_CREATE_ERROR,
    TEAM_MEMBER_LIST_FAILURE,
    TEAM_MEMBER_ADD_ERROR,
    TEAM_MEMBER_REMOVE_ERROR,
    USER_LIST_FAILURE,
    EMAIL_BLACKLIST_LIST_FAILURE,
    EMAIL_BLACKLIST_UPDATE_ERROR,
    SHORT_LINK_LIST_ERROR,
    SHORT_LINK_CREATE_ERROR,
    SHORT_LINK_ASSIGN_ABILITY_ERROR,
    SHORT_LINK_USER_LIST_ERROR,
    SHORT_LINK_DELETE_ERROR,
    SHORT_LINK_EDIT_ERROR,
    SHORT_LINK_DETAIL_ERROR,
    APPROVAL_TELEGRAM_GROUP_LIST_ERROR,
    APPROVAL_TELEGRAM_GROUP_CREATE_ERROR,
    APPROVAL_TELEGRAM_GROUP_DETAIL_ERROR,
    APPROVAL_TELEGRAM_GROUP_UPDATE_ERROR,
    APPROVAL_TELEGRAM_GROUP_DELETE_ERROR,
    APP_WITHOUT_COMPANY_LIST_FAILURE,
    GROUP_LIST_FAILURE,
    MSG_LIST_FAILURE, MSG_CREATE_FAILURE, GROUP_CREATE_FAILURE,
    COMPANY_APP_ACTION_FAILURE,
    COMPANY_APP_LIST_FAILURE,
    FAILURE_TOKEN, FAILURE_REGISTER_BY_EMAIL
} from '../types';
import {toast} from "react-toastify";
import {i18n} from "../language/i18n";

/**
 * @param {*} state
 * @param {*} action
 */
const ApiErrorMessageReducer = (state = {}, action) => {
    switch (action.type) {
        case TEAM_LIST_FAILURE:
        case TEAM_CREATE_ERROR:
        case TEAM_MEMBER_LIST_FAILURE:
        case TEAM_MEMBER_ADD_ERROR:
        case TEAM_MEMBER_REMOVE_ERROR:
        case USER_LIST_FAILURE:
        case MY_DOMAIN_LIST_FAILURE:
        case MY_COMPANIES_DOMAIN_LIST_FAILURE:
        case DOMAIN_CREATE_ERROR:
        case DOMAIN_DETAIL_FAILURE:
        case DOMAIN_EDIT_FAILURE:
        case TEMPLATE_LIST_FAILURE:
        case TEMPLATE_EDIT_ERROR:
        case TEMPLATE_DELETE_FAILURE:
        case DOMAIN_NOTIFY_LIST_FAILURE:
        case DOMAIN_CREATE_NOTIFY_ERROR:
        case FANPAGE_POST_CREATE_ERROR:
        case POST_ANSWER_LIST_ERROR:
        case POST_ANSWER_CREATE_ERROR:
        case ANSWER_UPDATE_ERROR:
        case ANSWER_DELETE_ERROR:
        case FANPAGE_ANSWER_CREATE_ERROR:
        case FANPAGE_POST_LIST_ERROR:
        case FANPAGE_POST_UPDATE_ERROR:
        case FANPAGE_LIST_FAILURE:
        case FANPAGE_GET_HEARS_FAILURE:
        case FAILURE_NAME_FANPAGE_FUNBOT:
        case FANPAGE_CREATE_ERROR:
        case FANPAGE_DETAIL_FAILURE:
        case FANPAGE_EDIT_FAILURE:
        case SEGMENT_CREATE_FAILURE:
        case SEGMENT_LIST_FAILURE:
        case SEGMENT_UPDATE_FAILURE:
        case APP_BY_KEY_LIST_FAILURE:
        case DOMAIN_NOTIFY_EMAIL_LIST_FAILURE:
        case EMAIL_BLACKLIST_LIST_FAILURE:
        case EMAIL_BLACKLIST_UPDATE_ERROR:
        case APP_LIST_FAILURE:
        case APP_WITHOUT_COMPANY_LIST_FAILURE:
        case COMPANY_APP_ACTION_FAILURE:
        case COMPANY_APP_LIST_FAILURE:
        case SHORT_LINK_LIST_ERROR:
        case SHORT_LINK_CREATE_ERROR:
        case SHORT_LINK_ASSIGN_ABILITY_ERROR:
        case SHORT_LINK_USER_LIST_ERROR:
        case SHORT_LINK_DELETE_ERROR:
        case SHORT_LINK_EDIT_ERROR:
        case SHORT_LINK_DETAIL_ERROR:
        case APPROVAL_TELEGRAM_GROUP_LIST_ERROR:
        case APPROVAL_TELEGRAM_GROUP_CREATE_ERROR:
        case APPROVAL_TELEGRAM_GROUP_DETAIL_ERROR:
        case APPROVAL_TELEGRAM_GROUP_UPDATE_ERROR:
        case APPROVAL_TELEGRAM_GROUP_DELETE_ERROR:
        case GROUP_LIST_FAILURE:
        case MSG_LIST_FAILURE:
        case MSG_CREATE_FAILURE:
        case GROUP_CREATE_FAILURE:
        case FAILURE_REGISTER_BY_EMAIL:
        case FAILURE_TOKEN:
            let message = action.payload.message;
            toast.error(i18n.t(message));
            return {...state, action};
        default:
            return {...state};
    }
};

export {
    ApiErrorMessageReducer
}